import { Avatar, ExternalLink, useIsMobile } from "@brg/ui";
import React, { FC, useMemo } from "react";
import {
  CompetitionJuryCardWrapper,
  CompetitionJuryCardText,
  CompetitionJuryDescriptionWrapper,
  CompetitionJuryCardImgContainer,
  CompetitionJuryCardLink
} from "../styles";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ShowMoreWithTags } from "shared/components/ShowMoreWithTags/ShowMoreWithTags";
import { AppTester } from "supporting";

interface IJuryCardProps {
  avatar?: string;
  fullName?: string;
  text?: string;
  tagsIds?: string[];
  onClick?: any;
  id?: string;
  isCGRave?: boolean;
  isShowcase?: boolean;
  showTags?: boolean;
  hasContext?: boolean
  href?: string;
}

export const CompetitionJuryCard: FC<IJuryCardProps> = ({ avatar, fullName, text, id, onClick, isCGRave, isShowcase, showTags, tagsIds, hasContext, href }) => {
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isMobile = useIsMobile();
  const theme = useTheme();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onClick(id);
  };

  const profileUrl = useMemo(() => {
    if (href) {
      return href
    }
    if (id) {
      return CreateLinkTo.designer(id);
    }
  }, [id, href]);

  const computeName = (fullName: string) => {
    const arr = fullName.split(' ');
    return `${arr[0] ?? ''} ${arr[2] ?? ''} ${arr[1] ?? ''} `
  }


  return (
    <CompetitionJuryCardWrapper>
      <CompetitionJuryCardLink to={profileUrl} external target="_self">
        <CompetitionJuryCardImgContainer isWideImg={hasContext} className="CompetitionJuryCardImgContainer" onClick={() => onClick(id)}>
          <Avatar fs={28} avatar={avatar} />
        </CompetitionJuryCardImgContainer>

        <CompetitionJuryCardText
          fontSize={isMobile ? "15" : "17"}
          //todo разобраться с цветами
          color={isCGRave || isAdcrDafesNet ? '#FFFFFF' : theme.competition.jury.name}
          fw={isShowcase ? '400' : "700"}
          lh={isMobile ? "20" : "22"}
        >
          {computeName(fullName ?? '')}
        </CompetitionJuryCardText>
      </CompetitionJuryCardLink>
      <CompetitionJuryDescriptionWrapper isShowcase={isShowcase} >
        <ShowMoreWithTags
          text={text ?? ''}
          tagsIds={tagsIds}
          showTags={showTags}
        />
      </CompetitionJuryDescriptionWrapper>
    </CompetitionJuryCardWrapper>

  )
}
import { Avatar, ExternalLink, useIsMobile } from "@brg/ui";
import React, { FC, useMemo } from "react";
import {
  CompetitionJuryCardWrapper,
  CompetitionJuryCardText,
  CompetitionJuryDescriptionWrapper,
  CompetitionJuryCardImgContainer,
  CompetitionJuryCardLink
} from "../styles";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ShowMoreWithTags } from "shared/components/ShowMoreWithTags/ShowMoreWithTags";
import { AppTester } from "supporting";

interface IJuryCardProps {
  avatar?: string;
  fullName?: string;
  text?: string;
  tagsIds?: string[];
  onClick?: any;
  id?: string;
  isCGRave?: boolean;
  isShowcase?: boolean;
  showTags?: boolean;
  hasContext?: boolean
  href?: string;
}

export const CompetitionJuryCard: FC<IJuryCardProps> = ({ avatar, fullName, text, id, onClick, isCGRave, isShowcase, showTags, tagsIds, hasContext, href }) => {
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isMobile = useIsMobile();
  const theme = useTheme();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onClick(id);
  };

  const profileUrl = useMemo(() => {
    if (href) {
      return href
    }
    if (id) {
      return CreateLinkTo.designer(id);
    }
  }, [id, href]);

  const computeName = (fullName: string) => {
    const arr = fullName.split(' ');
    return `${arr[0] ?? ''} ${arr[2] ?? ''} ${arr[1] ?? ''} `
  }


  return (
    <CompetitionJuryCardWrapper>
      <CompetitionJuryCardLink to={profileUrl} external target="_self">
        <CompetitionJuryCardImgContainer isWideImg={hasContext} className="CompetitionJuryCardImgContainer" onClick={() => onClick(id)}>
          <Avatar fs={28} avatar={avatar} />
        </CompetitionJuryCardImgContainer>

        <CompetitionJuryCardText
          fontSize={isMobile ? "15" : "17"}
          //todo разобраться с цветами
          color={isCGRave || isAdcrDafesNet ? '#FFFFFF' : theme.competition.jury.name}
          fw={isShowcase ? '400' : "700"}
          lh={isMobile ? "20" : "22"}
        >
          {computeName(fullName ?? '')}
        </CompetitionJuryCardText>
      </CompetitionJuryCardLink>
      <CompetitionJuryDescriptionWrapper isShowcase={isShowcase} >
        <ShowMoreWithTags
          text={text ?? ''}
          tagsIds={tagsIds}
          showTags={showTags}
        />
      </CompetitionJuryDescriptionWrapper>
    </CompetitionJuryCardWrapper>

  )
}
